<template>
	<div class="grid grid-cols-8 gap-y-4 gap-x-6 items-end">
		<!-- if we use this component also in another (not offer edit) context,
             we should allow columns to be flexible, for example, by passing ZIPclass parameter. -->
		<ui-input-group
			class="col-span-3 md:col-span-2"
			v-model="address.zip"
			:field="prefix + 'address.zip'"
			label="ZIP"
			:form="form"
			:required="true"
			v-on:change="fetchCitySuggestion"
			@change="triggerReload"
		>
		</ui-input-group>

		<ui-input-group
			class="col-span-5 md:col-span-3"
			v-model="address.city"
			:field="prefix + 'address.city'"
			label="City"
			:form="form"
			:required="true"
			:key="'CITY_INPUT.' + hack"
		></ui-input-group>

		<ui-select-group
			class="col-span-8 md:col-span-3"
			v-model="address.country"
			type="select"
			:field="prefix + 'address.country'"
			label="Country"
			:options="$cropOptions.countryOptions"
			:form="form"
			:required="true"
			:key="'COUNTRY_INPUT.' + hack"
		></ui-select-group>

		<div class="col-span-6 text-red-500" v-if="markInvalid">
			{{ validationMessage }}
		</div>
	</div>
</template>

<script>
export default {
	props: {
		value: {
			type: Object,
			required: true,
		},
		prefix: {
			type: String,
			default: "",
		},
		form: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			address: Vue.observable(this.value),
			cityOptions: [],
			hack: this._uid,
		};
	},
	computed: {
		formField() {
			let f = (this.prefix ? this.prefix + "." : "") + "address";
			return f;
		},
		markInvalid() {
			return this.form.hasErrors && this.form.errors[this.formField] != null;
		},
		validationMessage() {
			return this.form.errors[this.prefix + ".address"] || "";
		},
	},
	methods: {
		fetchCitySuggestion() {
			let zip = this.address.zip,
				that = this;
			if (("" + zip).length == 5 && !isNaN(zip) && !this.address.city) {
				// valid german zip, city field not field - try to look it up and autocomplete
				axios
					.get(window.baseUrl + "/api/zip/search", {
						params: {
							zip: zip,
						},
					})
					.then(function (response) {
						let d = response.data.data[0];
						if (d) {
							that.address.city = d.name;
							that.address.country = "DE";
							that.hack++;
						}
					});
			}
		},
		validationEventListener() {
			let that = this;
			console.log("is-mark-invalid", that.field, that.markInvalid);
			that.$bus.$emit("is-mark-invalid", that.field, that.markInvalid);
		},
		triggerReload() {
			if ("parentIFrame" in window) {
				window.parentIFrame.sendMessage("FULL_RELOAD");
			}
		},
	},
	created() {
		this.$bus.$on("poll-is-mark-invalid", this.validationEventListener);
	},
	beforeDestroy() {
		console.log("TURNING OFF", this.field);
		this.$bus.$off("poll-is-mark-invalid", this.validationEventListener);
	},
};
</script>
